import { ColumnMetadata } from "@valg-shared/components/table/table/column-metadata";
import {
  DateTimeRendererComponent
} from "@valg-shared/components/table/renderers/date-time-renderer/date-time-renderer.component";
import { WithPropsOfType } from "@valg-shared/forms";
import {
  BarChartRendererComponent
} from "@shared/components/table/renderers/bar-chart-renderer/bar-chart-renderer.component";
import { ElectionDto } from "@shared/clients/api.generated";
import { LinkRendererComponent } from "@shared/components/table/renderers/link-renderer/link-renderer.component";


const nonBreakingSpace = '\u00A0'
const spaces = `${nonBreakingSpace + nonBreakingSpace}`;

export const LatestUpdatesDistrictColumnDef: WithPropsOfType<LatestUpdatesDistrictDto, ColumnMetadata> = {
    district: {
        title: 'election_overview.latest_updates.table.header.district',
      presentationComponent: LinkRendererComponent,
      rendererOptions: new Map().set('link', 'nomination-district')
    },
    datetime: {
        title: 'election_overview.latest_updates.table.header.time',
        presentationComponent: DateTimeRendererComponent,
        format: `dd-LL-yyyy${spaces}HH:mm`,
    },
  id: { title: 'id', disable: true },
};

export interface ExtendedElectionDto extends ElectionDto {
  electionYear: number,
  isDisplayingMap: boolean,
  isDisplayingCards: boolean
}

export interface LatestUpdatesDistrictDto {
    id: string,
    district: string;
    datetime: Date | undefined;
}

export const LatestUpdatesMunicipalityColumnDef: WithPropsOfType<LatestUpdatesMunicipalityDto, ColumnMetadata> = {
    municipality: {
        title: 'election_overview.latest_updates.table.header.municipality',
        presentationComponent: LinkRendererComponent,
        rendererOptions: new Map().set('link', 'municipality')
    },
    datetime: {
        title: 'election_overview.latest_updates.table.header.time',
        presentationComponent: DateTimeRendererComponent,
        format: `dd-LL-yyyy${spaces}HH:mm`
    },
    id: { title: 'id', disable: true },
};
export interface LatestUpdatesMunicipalityDto {
    id: string;
    municipality: string;
    datetime: Date;
}

export const LatestUpdatesRegionColumnDef: WithPropsOfType<LatestUpdatesRegionDto, ColumnMetadata> = {
    region: {
        title: 'election_overview.latest_updates.table.header.region',
        presentationComponent: LinkRendererComponent,
        rendererOptions: new Map().set('link', 'region')
    },
    datetime: {
        title: 'election_overview.latest_updates.table.header.time',
        presentationComponent: DateTimeRendererComponent,
        format: `dd-LL-yyyy${spaces}HH:mm`
    },
    id: { title: 'id', disable: true },
};
export interface LatestUpdatesRegionDto {
    id: string;
    region: string;
    datetime: Date;
}

export const NUMBER_OF_DIPLAYED_UPDATES = 5;

export interface PartyStatusDto {
    name: string;
    percentage: number;
}

export const PartyStatusColumnDef: WithPropsOfType<PartyStatusDto, ColumnMetadata> = {
    name: {
        title: "",
        disable: true
    },
    percentage: {
        title: 'election_overview.party_status.table.header.percentage',
        presentationComponent: BarChartRendererComponent,
        rendererOptions: new Map().set('textPath', 'name'),
        defaultSort: 'desc'
    }
};
